var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":e => _vm.$emit('change', e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }